import { createSlice } from "@reduxjs/toolkit";
import appHelpers from "../../common/helpers/appHelpers";

export const sheetPaymentFiltersSlice = createSlice({
  name: "sheetPaymentFilters",
  initialState: { 
    code1List: [],
    code2List: [],
    code3List: [],
    code4List: [],
    code5List: [], 
    divisionList :[],
    departmentList : [],
    selectedCustomer:{
      code: "",
      description: "",
      id: -1

    },
    currencyList : []
  },
  reducers: {
    clearState: (state) => {
      state.selectedCustomer = {}; 
      return state;
    },
    onSelectGroupCodes: (state, action) => {
      state.code1List = action.payload.code1List;
      state.code2List = action.payload.code2List;
      state.code3List = action.payload.code3List;
      state.code4List = action.payload.code4List;
      state.code5List = action.payload.code5List;  
      return state;
    },
    onSelectDivisionList: (state, action) => {
      state.divisionList = action.payload; 
      return state;
    },
    onSelectdDepartmentList: (state, action) => {
      state.departmentList = action.payload; 
      return state;
    },
    onSelectCustomer: (state, action) => {
      state.selectedCustomer = action.payload; 
      return state;
    },
    clearSheetPaymentCustomer: (state, action) => {
      state.selectedCustomer = {}; 
      return state;
    },
    onSelectCurrencyTypes: (state, action) => {
 
      var list = action.payload;
      var platform = appHelpers.getPlatform();
      if (platform == "NETSIS") {
        if (list && list.length>0) {
          list.unshift({
            value: 0,
            label: "TRY",
          });
          list.unshift({
            value: -1,
            label: "Tümü",
          });
      
        }
      }
    
      state.currencyList = list; 
      return state;
    },
  },
});
export const { clearState, onSelectGroupCodes, onSelectDivisionList, onSelectdDepartmentList, onSelectCustomer, onSelectCurrencyTypes, clearSheetPaymentCustomer } = sheetPaymentFiltersSlice.actions;

 

export const sheetPaymentFiltersReducer = sheetPaymentFiltersSlice.reducer;